/**
 * StaffPortalLookupsService
 * Read-only lookups required by the staff portal UI.
 * Route: api/staff-portal/lookups
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
export class StaffPortalLookupsService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalLookupsService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalLookupsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async leaveTypes() {
        return (await this.leaveTypesRaw()).data ?? [];
    }
    leaveTypesRaw() {
        return this.get('leave-types');
    }
    async leaveStatuses() {
        return (await this.leaveStatusesRaw()).data ?? [];
    }
    leaveStatusesRaw() {
        return this.get('leave-statuses');
    }
    async leaveDocumentTypes() {
        return (await this.leaveDocumentTypesRaw()).data ?? [];
    }
    leaveDocumentTypesRaw() {
        return this.get('leave-document-types');
    }
    async fileTypes() {
        return (await this.fileTypesRaw()).data ?? [];
    }
    fileTypesRaw() {
        return this.get('file-types');
    }
    async fileCategories() {
        return (await this.fileCategoriesRaw()).data ?? [];
    }
    fileCategoriesRaw() {
        return this.get('file-categories');
    }
    async employeeTypes() {
        return (await this.employeeTypesRaw()).data ?? [];
    }
    employeeTypesRaw() {
        return this.get('employee-types');
    }
    async employeeStatuses() {
        return (await this.employeeStatusesRaw()).data ?? [];
    }
    employeeStatusesRaw() {
        return this.get('employee-statuses');
    }
    async announcementTypes() {
        return (await this.announcementTypesRaw()).data ?? [];
    }
    announcementTypesRaw() {
        return this.get('announcement-types');
    }
    /** Active colleagues the staff member can delegate duties to. */
    async colleagues() {
        return (await this.colleaguesRaw()).data ?? [];
    }
    colleaguesRaw() {
        return this.get('colleagues');
    }
    /** Curated quick-view of a single colleague — contact details + KPIs. */
    async getColleague(userId) {
        return (await this.getColleagueRaw(userId)).data ?? null;
    }
    getColleagueRaw(userId) {
        return this.get(`colleagues/${userId}`);
    }
    /** Duty catalogue — also exposed by StaffPortalDutyService.getDutyCatalogue, included here for convenience. */
    async dutyCatalogue() {
        // Reach out to the staff-portal duties endpoint directly so the dropdown can
        // share the same base service path as the rest of the lookups.
        const url = this.buildUrl().replace(/\/lookups$/, '/duties/catalogue');
        const res = await this.http.get(url);
        return res?.data ?? [];
    }
}
// Routes through the HRManagement API gateway — see StaffPortalDutyService.
StaffPortalLookupsService.DEFAULT_SERVICE_PATH = 'hr';
StaffPortalLookupsService.BASE_PATH = 'api/staff-portal/lookups';
//# sourceMappingURL=StaffPortalLookupsService.js.map